import { Injectable } from '@angular/core';
import { AnyHandler, SimpleATHandler, SimpleAVHandler, SimpleTHandler } from '../types/@types/sl-v-types';

@Injectable({
  providedIn: 'root'
})
export class ClipboardService {

  constructor() { }

  Paste(okHandler: SimpleAVHandler<string>, errHandler?: SimpleAVHandler<string>) {
    navigator.clipboard.readText().then((value) => {
      okHandler(value)
    }, (reason) => {
      if (!errHandler) {
        console.error('Failed to read clipboard content:'+ reason);
      } else {
        errHandler(reason);
      }
    });

  }
}
